export interface ISousMatiere {
  id?: string;
  nom?: string;
  cycleMatiereId?: string;
  ordre?: number;
  actif?: boolean;
}

export const defaultValue: Readonly<ISousMatiere> = {
  id: '',
  nom: '',
  cycleMatiereId: '',
  actif: true,
};
